module.exports = __webpack_public_path__ + "img/blog-4-3.1bfc68ea.webp";